import { ARandom } from "./arandom.js";
class WrappedRandom extends ARandom {
  constructor(rnd) {
    super();
    this.rnd = rnd;
  }
  float(norm = 1) {
    return this.rnd() * norm;
  }
  norm(norm = 1) {
    return (this.rnd() - 0.5) * 2 * norm;
  }
  int() {
    return this.rnd() * 4294967296 >>> 0;
  }
}
export {
  WrappedRandom
};
